export default __webpack_public_path__ + "static/media/PJL04.226bcd80.png";